import { css } from '@emotion/react';
import styled from '@emotion/styled';
import breakpoints from './Theme/breakpoints';
import InnerHtml from './InnerHtml';

const markdownStyling = css`
  font-family: var(--font-article);
  color: var(--black-high);
  line-height: 1.75rem;
  scroll-behaviour: smooth;

  p, a, div, span, u, strong, li, ul, ol, pre, code, hr, blockquote, table {
    font-size: var(--size-body1);
  }

  blockquote {
    font-family: var(--font-secondary);
    border-left: 4px solid var(--primary-color);
    padding-left: 16px;
    margin: 32px 32px 32px;
  }

  blockquote p {
    font-family: var(--font-secondary);
  }

  iframe {
    /* override inline image style */
    /* stylelint-disable-next-line declaration-no-important */
    width: 100vw !important;
    margin: -16px;
  }

  @media (min-width: ${breakpoints.sm}px) {
    iframe {
      /* override inline image style */
      /* stylelint-disable-next-line declaration-no-important */
      width: calc(100vw - 32px) !important;
      margin: 0 0 0 calc(-50vw + 291px);
    }
  }

  @media (min-width: ${breakpoints.md}px) {
    iframe {
      /* override inline image style */
      /* stylelint-disable-next-line declaration-no-important */
      width: calc(100vw - 40px) !important;
      margin: 0 0 0 calc(-50vw + 295px);
    }
  }

  @media (min-width: ${breakpoints.lg}px) {
    iframe {
      max-width: 700px;
      /* override inline image style */
      /* stylelint-disable-next-line declaration-no-important */  
      width: 700px !important;
      margin: 0 0 0 -75px;
    }
  }

  iframe[src*="instagram.com"],
  iframe[src*="youtube.com"],
  iframe[src*="vimeo.com"] {
    max-width: 100%;
    margin: 0;
  }

  figure iframe {
    max-width: 100%;
  }

  a {
    color: var(--blue);
  }

  figcaption {
    font-family: var(--mdc-typography-font-family);
    font-size: var(--size-caption);
    color: var(--black-medium);
    text-align: center;
    padding: 0 16px;
  }

  h1 {
    font-size: var(--size-h3);
    line-height: 56px;
    letter-spacing: -0.1rem;
    margin: 48px 0 12px;
  }

  h2 {
    font-size: var(--size-h4);
    line-height: 40px;
    letter-spacing: -0.08rem;
    margin: 32px 0 8px;
  }

  h3 {
    font-size: var(--size-h5);
    line-height: 28px;
    letter-spacing: -0.07rem;
    margin: 24px 0 4px;
  }

  h4 {
    line-height: 24px;
  }

  h5 {
    line-height: 20px;
  }

  h6 {
    line-height: 16px;
  }

  h4, h5, h6 {
    margin: 16px 0 4px;
  }

  h2, h3 {
    line-height: 1.75rem;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-secondary);
    color: var(--black-high);
  }

  /* stylelint-disable-next-line selector-type-no-unknown */
  .image-container img, .image-container progressive-img {
    width: 100%;
  }

  small {
    font-size: 88%;
  }

  .panel.panel-default {
    border: 1px solid var(--grey-light);
    padding: 16px;
  }

  .article-promo,
  .article-promo--alt {
    font-family: var(--font-primary);
    font-size: var(--size-body);
    line-height: 1.25rem;
    margin: 24px 0;

    a, header {
      color: var(--primary-color);
    }

    p, u, header, a {
      font-size: var(--size-body);
      line-height: 1.25rem;
    }

    header {
      font-weight: bold;
      text-transform: uppercase;
      margin: 0 0 8px;
    }

    p:last-of-type {
      margin: 0;
    }
  }

  .article-promo {
    background-color: #f8f8f8;
    border-radius: 20px;
    padding: 24px;
  }

  .article-promo--alt {
    border: 1px solid var(--primary-color);
    border-width: 1px 0;
    padding: 24px 0;
  }

  .embed-responsive {
    position: relative;
    display: block;
    height: 0;
    padding: 0;
    overflow: hidden;
  }

  .embed-responsive iframe {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    border: 0;
  }

  .embed-responsive-16by9 {
    padding-bottom: 56.25%;
  }

  .fu-google-maps {
    position: relative;
    overflow: hidden;
    height: 0;
    padding-bottom: 75%;
  }

  .fu-google-maps iframe {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    border: none;
  }

  > figure, > .image-container, > .embed-responsive, > .fu-google-maps {
    margin-left: -16px;
    margin-right: -16px;
  }

  @media (min-width: ${breakpoints.md}px) {
    > figure, > .image-container, > .embed-responsive, > .fu-google-maps {
      margin-left: 0;
      margin-right: 0;
    }

    > .image-container {
      min-height: 196px;
    }
  }
`;

const InnerHtmlStyling = styled(InnerHtml)`
  /* stylelint-disable-next-line no-descending-specificity */
  p, div, span, u, strong, ul, ol, code, hr, table, blockquote p {
    margin: 0 0 16px;
  }

  /* stylelint-disable-next-line no-descending-specificity */
  p, a, div, span, u, strong, li, ul, ol, pre, code, hr, blockquote, table {
    line-height: 1.75rem;
  }

  ${markdownStyling}
`;

export {
  InnerHtmlStyling as default,
  markdownStyling,
};
